module.exports = __webpack_public_path__ + "media/images/bsmart/icons/side_menu_report_attivo-d8f907bea720d93edd934aac154e2a94.svg";